export const generateUid = () =>
  `${new Date().getTime()}_${Math.random().toString(36).slice(2, 7)}`;
